class RangerSlider {

    constructor(container) {
        this.container       = container
        this.touchLeft       = this.container.querySelector('.slider-touch-left')
        this.touchRight      = this.container.querySelector('.slider-touch-right')
        this.current         = this.container.querySelector('.slider-current')
        this.min             = parseFloat(this.container.getAttribute('data-range-min'))
        this.max             = parseFloat(this.container.getAttribute('data-range-max'))
        this.defaultMinValue = (this.container.hasAttribute('data-range-value-min')) ? parseFloat(this.container.getAttribute('data-range-value-min')) : this.min
        this.defaultMaxValue = (this.container.hasAttribute('data-range-value-max')) ? parseFloat(this.container.getAttribute('data-range-value-max')) : this.max
        this.startX          = 0
        this.x               = 0
        this.step            = (this.container.getAttribute('data-range-step')) ? Math.abs(parseFloat(this.container.getAttribute('data-range-step'))) : 0.0
        this.normalizeFact   = 26
    }

    init() {

        this.checkValues()
        this.reset()
        this.maxX = this.container.offsetWidth - this.touchRight.offsetWidth
        console.log(this.maxX)
        this.selectedTouch = null
        this.initialValue = (this.current.offsetWidth - this.normalizeFact)

        this.setMinValue(this.defaultMinValue)
        this.setMaxValue(this.defaultMaxValue)

        this.touchLeft.addEventListener('mousedown', this.onStart.bind(this))
		this.touchRight.addEventListener('mousedown', this.onStart.bind(this))
		this.touchLeft.addEventListener('touchstart', this.onStart.bind(this))
		this.touchRight.addEventListener('touchstart', this.onStart.bind(this))
    }

    checkValues() {

        if (this.defaultMinValue < this.min)
            this.defaultMinValue = this.min

        if (this.defaultMaxValue > this.max)
            this.defaultMaxValue = this.max

        if (this.defaultMinValue > this.defaultMaxValue)
            this.defaultMinValue = this.defaultMaxValue
    }

    reset() {
        this.touchLeft.style.left = '0'
        this.touchRight.style.left = this.getRem((this.container.offsetWidth - this.touchLeft.offsetWidth))
        this.current.style.marginLeft = '0'
        this.current.style.width = this.getRem((this.container.offsetWidth - this.touchLeft.offsetWidth))
        this.startX = 0
        this.x = 0
    }

    setMinValue(minValue) {
        let ratio = ((minValue - this.min) / (this.max - this.min))
        this.touchLeft.style.left = this.getRem(Math.ceil(ratio * (this.container.offsetWidth - (this.touchLeft.offsetWidth + this.normalizeFact))))
        this.current.style.marginLeft = this.getRem(this.touchLeft.offsetLeft)
        this.current.width = this.getRem((this.touchRight.offsetLeft - this.touchLeft.offsetLeft))
        this.container.setAttribute('data-range-value-min', minValue)
    }

    setMaxValue(maxValue) {
        let ratio = ((maxValue - this.min) / (this.max - this.min))
        this.touchRight.style.left =  this.getRem(Math.ceil(ratio * (this.container.offsetWidth - (this.touchLeft.offsetWidth + this.normalizeFact)) + this.normalizeFact))
        this.current.style.marginLeft = this.getRem(this.touchLeft.offsetLeft)
        this.current.style.width = this.getRem((this.touchRight.offsetLeft - this.touchLeft.offsetLeft))
        this.container.setAttribute('data-range-value-max', maxValue)
    }

    onStart(e) {
        e.preventDefault()

        let eventTouch = (e.touches) ? e.touches[0] : e

        if (e.target === this.touchLeft || e.target === this.touchRight) {
            this.target = e.target
            this.target.classList.add('moved')
        }
        
        this.x = (e.target === this.touchLeft) ? this.touchLeft.offsetLeft : this.touchRight.offsetLeft

        this.startX = eventTouch.pageX - this.x
        this.selectedTouch = e.target
        document.addEventListener('mousemove', this.onMove.bind(this))
        document.addEventListener('mouseup', this.onStop.bind(this))
        document.addEventListener('touchmove', this.onMove.bind(this))
        document.addEventListener('touchend', this.onStop.bind(this))
    }

    onMove(e) {
        let eventTouch = (e.touches) ? e.touches[0] : e

        this.x = eventTouch.pageX - this.startX

        if (this.selectedTouch === this.touchLeft) {

            if (this.x > (this.touchRight.offsetLeft - this.selectedTouch.offsetWidth - 6)) {
                this.x = this.touchRight.offsetLeft - this.selectedTouch.offsetWidth - 6
            }
            else if (this.x < 0) {
                this.x = 0
            }

            this.selectedTouch.style.left = this.getRem(this.x)
        } else if (this.selectedTouch === this.touchRight) {
            if (this.x < (this.touchLeft.offsetLeft + this.touchLeft.offsetWidth + 6)) {
                this.x = this.touchLeft.offsetLeft + this.touchLeft.offsetWidth + 6
            }
            else if (this.x > this.maxX) {
                console.log('this.x', this.x)
                console.log('this.maxX', this.maxX)
                this.x = this.maxX
            }

            this.selectedTouch.style.left = this.getRem(this.x)
        }

        this.current.style.marginLeft = this.getRem(this.touchLeft.offsetLeft)
        this.current.style.width      = this.getRem((this.touchRight.offsetLeft - this.touchLeft.offsetLeft))

        this.calculateValue()

        if (this.container.getAttribute('on-change')) {
            let fn = new Function('min, max', this.container.getAttribute('on-change'))
            fn(this.container.getAttribute('data-range-value-min'), this.container.getAttribute('data-range-value-max'))
        }

        if (this.onChange)
            this.onChange(this.container.getAttribute('data-range-value-min'), this.container.getAttribute('data-range-value-max'))
        
    }

    onStop() {
        document.removeEventListener('mousemove', this.onMove.bind(this))
        document.removeEventListener('mouseup', this.onStop.bind(this))
        document.removeEventListener('touchmove', this.onMove.bind(this))
        document.removeEventListener('touchend', this.onStop.bind(this))

        if (this.target && this.target.classList.contains('moved')) {
            this.target.classList.remove('moved')
            this.target = null
        }
        
        this.selectedTouch = null

        this.calculateValue()

        if (this.container.getAttribute('did-changed')) {
            let fn = new Function('min, max', this.container.getAttribute('did-changed'))
            fn(this.container.getAttribute('data-range-value-min'), this.container.getAttribute('data-range-value-max'))
        }

        if (this.didChanged)
            this.didChanged(this.container.getAttribute('data-range-value-min'), this.container.getAttribute('data-range-value-max'))
    }

    calculateValue() {
        let newValue = (this.current.offsetWidth - this.normalizeFact) / this.initialValue,
            minValue = this.current.offsetLeft / this.initialValue,
            maxValue = minValue + newValue

        minValue = minValue * (this.max - this.min) + this.min
        maxValue = maxValue * (this.max - this.min) + this.min

        if (this.step !== 0.0) {
            let multi = Math.floor(minValue / this.step)
            minValue = this.step * multi

            multi = Math.floor(maxValue / this.step)
            maxValue = this.step * multi
        }

        this.container.setAttribute('data-range-value-min', minValue)
        this.container.setAttribute('data-range-value-max', maxValue)
    }

    getRem($nb) {
        return $nb / 10 + 'rem'
    }
}

export { RangerSlider }